import { fDate } from "../utils/formatTime";

export const handleDateInput = ({
    event,
    name,
    minDate = new Date(2017, 0, 1),
    maxDate = new Date(),
    onBlur,
}) => {
    const regex = /^[0-9/]$/;

    if (
        !regex.test(event.key) &&
        event.key !== "Backspace" &&
        event.key !== "Delete" &&
        !(event.ctrlKey && event.key === "v") &&
        event.key !== "Enter" &&
        event.key !== "Tab"
    ) {
        event.preventDefault();
        return;
    }

    const input = event.target.value;

    if (event.key !== "Backspace" && event.key !== "Delete") {
        if (input?.length === 2 || input?.length === 5) {
            event.target.value = input + "/";
        }
    }

    if (event.key === "Enter") {
        event.preventDefault();

        const inputValue = event.target.value;

        if (inputValue && inputValue.length === 10) {
            const [day, month, year] = inputValue.split("/").map(Number);
            const inputDate = new Date(year, month - 1, day);

            if (isNaN(inputDate.getTime())) {
                alert("Invalid date format");
                return;
            }

            if (minDate && inputDate < minDate) {
                event.target.value = fDate(minDate);
            } else if (maxDate && inputDate > maxDate) {
                event.target.value = fDate(maxDate);
            }
        }

        onBlur?.(event, name, event.target.value);
    }
};